import React from "react";

import { dateTimeStr } from "../../../libs/Util";
import { IReportEntry } from "../../../state";
import caution from "../../../assets/icon/caution.svg";
import person from "../../../assets/icon/person.svg";

import styles from "./ReportEntry.module.scss";
import Avatar from "../../../molecules/Avatar";

export interface ReportEntryProps {
  report_entry: IReportEntry;
  onDelete?: (realization_id: number) => void;
}

export const ReportEntry = (props: ReportEntryProps) => {
  return (
    <div className={styles.entry}>
      <div className={styles.from}>
        <img src={caution} alt="caution" />
        {props.report_entry.reporters.length > 1
          ? `${props.report_entry.reporters[0]}さん、他${
              props.report_entry.reporters.length - 1
            }名から報告されました。`
          : `${props.report_entry.reporters[0]}さんから報告されました。`}
      </div>
      <div className={styles.entryArea}>
        <div className={styles.imageArea}>
          {props.report_entry.photo?.url ? (
            <Avatar
              src={props.report_entry.photo.url}
              alt="プロフィール画像"
              size={80}
            />
          ) : (
            <Avatar src={person} alt="no_image" size={80} />
          )}
        </div>
        <div className={styles.contentArea}>
          <div className={styles.name}>
            {props.report_entry.class_name} {props.report_entry.student_name}の
            {props.report_entry.comment_id ? "コメント" : "ストック"}
          </div>
          <div className={styles.content}>{props.report_entry.content}</div>
          <div className={styles.time}>
            {dateTimeStr(props.report_entry.created_at)}
          </div>
          {props.onDelete && (
            <button
              className={styles.deleteButton}
              onClick={() => props.onDelete!(props.report_entry.realization_id)}
              title="この報告を削除"
            >
              削除
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportEntry;
